import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2809081c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2809081c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2809081c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809081c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2809081c')) {
      api.createRecord('2809081c', component.options)
    } else {
      api.reload('2809081c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2809081c&scoped=true", function () {
      api.rerender('2809081c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabMessagerc/index.vue"
export default component.exports